import React from 'react';

import { useIsMediumAndAbove } from '../../../hooks/mediaQueries.js';
import TRANSLATIONS from '../../../translations/translations@default.json';

const SortByDefaultOption = () => {
	const isMediumAndAbove = useIsMediumAndAbove();

	return (
		<option
			key="default"
			value="default"
			disabled
			hidden
			data-testid="sort-by__option">
			{isMediumAndAbove
				? TRANSLATIONS.controls.sortBy.pleaseSelect
				: TRANSLATIONS.controls.sortBy.sortByButton}
		</option>
	);
};

export default SortByDefaultOption;
